import { render, staticRenderFns } from "./datastore-item.vue?vue&type=template&id=616f9edb&scoped=true&"
import script from "./datastore-item.vue?vue&type=script&lang=js&"
export * from "./datastore-item.vue?vue&type=script&lang=js&"
import style0 from "./datastore-item.vue?vue&type=style&index=0&id=616f9edb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616f9edb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VChip,VIcon})
